import React from 'react';
import { PictoProps } from './index';

export const CaretRightFilled = (props: PictoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '6'}
    height={props.height || '12'}
    viewBox="0 0 6 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.48227e-05 0L4.48227e-05 11.1429L5.89819 5.57143L4.48227e-05 0Z"
      fill="#004653"
    />
  </svg>
);
